import { compose } from 'redux'

// higher-order components
import withQueryResults from 'components/shared/withQueryResults'
import withRedux from './withRedux'
import withQuery from './withQuery'
import withEventHandlers from './withEventHandlers'

// presentational component
import UI from './UI'

export default compose(
  withRedux, // for setting error state
  withQueryResults, // for handling query errors
  withQuery, // for fetching account data
  withEventHandlers // for UI interactions
)(UI)
